import { CustomerRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import { fn } from "util";

class DataTablePresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      content: [],
      filters: {},
      order: {
        field: "name",
        direction: "ASC"
      },
      errorable: {
        visible: false,
        content: ""
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: 0
      }
    };
  }

  async onStart() {
    await this.load();
  }

  async load() {
    this.enqueue({ loading: true });
    this.renewCancelToken();

    const { pagination } = this.viewModel;
    const repositoryResult = await CustomerRepository.getListOnline({
      order: [this.viewModel.order],
      pagination: {
        page: pagination.currentPage,
        perPage: pagination.perPage
      },
      filters: await this.getFilters()
    });

    if (repositoryResult.success) {
      this.enqueue(vm => ({
        content: repositoryResult.data,
        pagination: {
          ...vm.pagination,
          total: repositoryResult.total,
          perPage: repositoryResult.perPage
        }
      }));
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Nosso serviço encontra-se indisponível. Tente novamente mais tarde."
      });
    } else if (!repositoryResult.userCancelled) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não foi possível carregar os dados. Tente novamente mais tarde."
      });
    }

    this.enqueue({ loading: false });
  }

  async getFilters() {
    const { name, email, identification, phone } = this.props.filters;
    const filters = [];
    //  Cannot read property 'get' of undefined problem - concurrency?

    if (!fn.isBlank(name)) {
      filters.push({
        connector: "AND",
        field: "name",
        operation: "LIKE",
        value: name
      });
    }
    if (!fn.isBlank(email)) {
      filters.push({
        connector: "AND",
        field: "email",
        operation: "LIKE",
        value: email
      });
    }
    if (!fn.isBlank(identification)) {
      filters.push({
        connector: "AND",
        field: "identification",
        operation: "LIKE",
        value: identification
      });
    }
    if (!fn.isBlank(phone)) {
      filters.push({
        connector: "AND",
        field: "phone",
        operation: "LIKE",
        value: phone
      });
    }

    filters.push({
      connector: "AND",
      field: "deleted",
      operation: "NOT",
      value: true
    });

    return filters;
  }

  async onFilterChange(fields) {
    this.enqueue({ filters: fields });
    await this.load();
  }

  onPageChange(page) {
    this.enqueue(
      vm => ({
        pagination: {
          ...vm.pagination,
          currentPage: page
        }
      }),
      () => this.load()
    );
  }

  onOrderChange(field, direction) {
    this.enqueue(
      vm => ({
        order: {
          ...vm.order,
          field,
          direction
        }
      }),
      () => this.load()
    );
  }

  async onViewCustomer(customer) {
    this.navigateTo("app.registration.customer.view", {
      customerUuid: customer.uuid
    });
  }

  async onEditCustomer(customer) {
    this.navigateTo("app.registration.customer.edit", {
      customerUuid: customer.uuid
    });
  }

  async onRequestDelete(customer) {
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o cliente ${customer.identifier()}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDelete(customer)
        }
      ]
    });
  }

  async doDelete(customer) {
    this.enqueue({ loading: true });

    const repositoryResult = await CustomerRepository.delete(customer.uuid);

    if (repositoryResult.success) {
      await this.load();
      this.sendNotification({
        type: "success",
        content: "O cliente foi excluído."
      });
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: "Ocorreu um erro na conexão. Tente novamente mais tarde."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: repositoryResult.error
      });
    }

    this.enqueue({ loading: false });
  }
}

export default DataTablePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/data-table/presenter.js